export default "__VITE_ASSET__snCKz1Ft__"